<template>
  <router-view />
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="scss">
#app {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,
    Arial, sans-serif;
}

.marker-icon {
  & > div {
    @apply w-full h-full bg-opacity-50 rounded-full;
    @apply border border-solid;
  }
}

.layer-tooltip.leaflet-tooltip {
  @apply w-[100px] text-[10px] p-0 pb-[1.5px] px-[2px] bg-opacity-50;
  @apply border-none leading-none text-center whitespace-normal;
  pointer-events: none;
}
</style>
